export default __webpack_public_path__ + "static/media/axfina_logo_short_white.bb9f7a21.svg";